function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import heart from './heart.json';
import LottieAnimation from '../LottieAnimation';

const Heart = ({ ...props
}) => /*#__PURE__*/React.createElement(LottieAnimation, _extends({
  icon: heart,
  ariaLabel: "hartje icoon"
}, props));

export default Heart;